/// <reference path="appbase.ts" />

namespace TerminalApp {
    let appId = "app_empty";

    export class App_Empty extends AppBase {
        constructor() {
            super(appId);
        }
    }

    RegisterApp(appId, App_Empty);
}